<template>
  <div style="padding:0 0 20px 0;margin-bottom: 20px;">
    <div v-for="(item, index) in giftList" :key="index" style="margin-top: 20px;">
      <prize :prizs="item"></prize>
      <div style="display: flex;justify-content: center;">
        <el-button type="danger" size="mini" @click="removeList(index)">-删除奖品</el-button>
      </div>
    </div>
    <div style="display: flex;justify-content: center;margin-top: 14px;">
      <el-button type="primary" size="mini" @click="addList">+增加奖品</el-button>
    </div>
  </div>
</template>

<script>
import prize from '@/components/prize/index.vue'
import { getArrList } from '@/api/demo/discount/index'
import { getLuckList } from '@/api/demo/luckDraw/index'
import { getMedalList } from '@/api/demo/medal/index'
import { attList } from '@/api/demo/attributes/index'
import { getCRList, getCard } from '@/api/demo/CommissionRelate/index'
import uploadImg from '@/components/uploadImage/index.vue'
import { getThemeList } from '@/api/demo/punchInActivity/index'
export default {
  name: 'gifts',
  props: {
    giftList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    uploadImg,
    prize
  },
  data () {
    return {
      couponsList: [], // 优惠券列表
      rafflesList: [], // 抽奖列表
      medalsList: [], // 勋章列表
      getCRsList: [], // 委托管理
      getsThemeList: [],
      listLoading: false,
      options: [
        { label: '亲密关系', options: [] },
        { label: '气质特征', options: [] },
        { label: '能力属性', options: [] }
      ]
    }
  },
  created () {
    let that = this
    that.couponList()
    that.raffleList()
    that.medalList()
    that.getCRList()
    that.getAttributes()
    that.getThemesList()
  },
  methods: {
    // 新增
    addList () {
      let that = this
      that.giftList.push({
        count: 0, // 数量
        icon: '', // 奖品图标
        name: null, // 奖品名称
        type: 0, // 0 无奖品 1 实体物品 2 克拉数 3 优惠券 4 经验值 5 抽奖机会
        value: null, // 虚拟物品值
        getCardList: [] // 卡片集合
      })
    },
    // 删除
    removeList (index) {
      let that = this
      that.giftList.splice(index, 1)
      that.giftList.forEach((item, index) => {
        item.index = index
      })
    },
    // 卡片列表
    getCardsList (e, index) {
      let that = this
      getCard(e).then(res => {
        that.giftList[index].getCardList = res
      })
    },
    // 获取打卡任务
    getThemesList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 2000,
        classifyId: null,
        keyword: null,
        status: 1
      }
      getThemeList(listQuery).then(res => {
        that.getsThemeList = res.records
      })
    },
    // 优惠券
    couponList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        stat: 1,
        type: ''
      }
      getArrList(listQuery).then(res => {
        that.couponsList = res.records
      })
    },
    // 抽奖列表
    raffleList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        name: null, // 名称
        pageSize: 200, // 每页显示的大小
        status: 1 // 状态
      }
      getLuckList(listQuery).then(res => {
        that.rafflesList = res.records
      })
    },
    // 勋章列表
    medalList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200 // 每页显示的大小
      }
      getMedalList(listQuery).then(res => {
        that.medalsList = res.records
      })
    },
    getCRList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200, // 每页显示的大小
        status: 1
      }
      getCRList(listQuery).then(res => {
        that.getCRsList = res.records
      })
    },
    // 获取属性相关
    getAttributes () {
      let listQuery = {
        currentPage: 1,
        pageSize: 40
      }
      attList(listQuery, 1).then(res => {
        res.records.forEach(item => {
          this.options[0].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 2).then(res => {
        res.records.forEach(item => {
          this.options[1].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 4).then(res => {
        res.records.forEach(item => {
          this.options[2].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
    },
    // 类型
    skuType (e, index) {
      let that = this
      for (let index2 = 0; index2 < that.giftList.length; index2++) {
        if (that.giftList[index2] == index) {
          that.giftList[index2].type = e
        }
      }
    },
    skusType (e, index) {
      console.log('ee', e, index)
      let that = this
      if (e == '') {
      } else {
        that.getCardsList(e, index)
      }
    }
  }
}
</script>
